// import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { authApi } from "../../config/api";
// import { toast } from "react-toastify";

// // Create Hot List
// export const createHotList = createAsyncThunk(
//   "hotlist/create",
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await authApi.post(
//         "/company/recruiter/hot-list/",
//         formData
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Get All Hot Lists
// export const getHotLists = createAsyncThunk(
//   "hotlist/fetchAll",
//   async (_, { rejectWithValue }) => {
//     try {
//       const response = await authApi.get("/company/recruiter/hot-list/");
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Delete Hot List
// export const deleteHotList = createAsyncThunk(
//   "hotlist/delete",
//   async (hot_list_id, { rejectWithValue }) => {
//     try {
//       const response = await authApi.delete(
//         `/company/recruiter/hot-list/?hot_list_id=${hot_list_id}`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Create Candidate in Hot List
// export const createCandidate = createAsyncThunk(
//   "hotlist/createCandidate",
//   async (formData, { rejectWithValue }) => {
//     try {
//       const response = await authApi.post(
//         "/company/recruiter/hot-list/candidate/",
//         formData
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Get Candidate Details
// export const getCandidate = createAsyncThunk(
//   "hotlist/getCandidate",
//   async (candidate_id, { rejectWithValue }) => {
//     try {
//       const response = await authApi.get(
//         `/company/recruiter/hot-list/candidate/${candidate_id}/`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Update Candidate
// export const updateCandidate = createAsyncThunk(
//   "hotlist/updateCandidate",
//   async ({ candidate_id, data }, { rejectWithValue }) => {
//     try {
//       const response = await authApi.put(
//         `/company/recruiter/hot-list/candidate/${candidate_id}/`,
//         data
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Delete Candidate
// export const deleteCandidate = createAsyncThunk(
//   "hotlist/deleteCandidate",
//   async (candidate_id, { rejectWithValue }) => {
//     try {
//       const response = await authApi.delete(
//         `/company/recruiter/hot-list/candidate/${candidate_id}/`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Get Candidate List by Hot List ID
// export const getCandidateList = createAsyncThunk(
//   "hotlist/candidateList",
//   async (hot_list_id, { rejectWithValue }) => {
//     try {
//       const response = await authApi.get(
//         `/company/recruiter/hot-list/candidate-list/${hot_list_id}/`
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// // Publish Hot List
// export const publishHotList = createAsyncThunk(
//   "hotlist/publish",
//   async (data, { rejectWithValue }) => {
//     try {
//       const response = await authApi.patch(
//         `/company/recruiter/hot-list/publish/`,
//         data
//       );
//       return response.data;
//     } catch (error) {
//       return rejectWithValue(error.response?.data || "Something went wrong");
//     }
//   }
// );

// const hotListSlice = createSlice({
//   name: "hotlist",
//   initialState: {
//     hotLists: [],
//     candidates: [],
//     candidateDetail: null,
//     status: "idle",
//     error: null,
//     loading: {
//       createHotList: "idle",
//       getHotLists: "idle",
//       deleteHotList: "idle",
//       createCandidate: "idle",
//       getCandidate: "idle",
//       updateCandidate: "idle",
//       deleteCandidate: "idle",
//       getCandidateList: "idle",
//       publishHotList: "idle",
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       // Create Hot List
//       .addCase(createHotList.pending, (state) => {
//         state.loading.createHotList = "pending";
//         state.status = "loading";
//       })
//       .addCase(createHotList.fulfilled, (state, action) => {
//         state.loading.createHotList = "succeeded";
//         state.status = "created";
//         state.hotLists.push(action.payload); // Add new hotlist to state
//         toast.success(
//           action.payload?.message || "Hotlist created successfully"
//         );
//       })
//       .addCase(createHotList.rejected, (state, action) => {
//         state.loading.createHotList = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to create hotlist");
//       })

//       // Get All Hot Lists
//       .addCase(getHotLists.pending, (state) => {
//         state.loading.getHotLists = "pending";
//         state.status = "loading";
//       })
//       .addCase(getHotLists.fulfilled, (state, action) => {
//         state.loading.getHotLists = "succeeded";
//         state.hotLists = action.payload;
//         state.status = "succeeded";
//       })
//       .addCase(getHotLists.rejected, (state, action) => {
//         state.loading.getHotLists = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to fetch hotlists");
//       })

//       // Delete Hot List
//       .addCase(deleteHotList.pending, (state) => {
//         state.loading.deleteHotList = "pending";
//         state.status = "loading";
//       })
//       .addCase(deleteHotList.fulfilled, (state, action) => {
//         state.loading.deleteHotList = "succeeded";
//         state.status = "deleted";
//         state.hotLists = state.hotLists.filter(
//           (hotlist) => hotlist.id !== action.meta.arg // Remove deleted hotlist
//         );
//         toast.success(
//           action.payload?.message || "Hotlist deleted successfully"
//         );
//       })
//       .addCase(deleteHotList.rejected, (state, action) => {
//         state.loading.deleteHotList = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to delete hotlist");
//       })

//       // Create Candidate
//       .addCase(createCandidate.pending, (state) => {
//         state.loading.createCandidate = "pending";
//         state.status = "loading";
//       })
//       .addCase(createCandidate.fulfilled, (state, action) => {
//         state.loading.createCandidate = "succeeded";
//         state.status = "candidate_created";
//         state.candidates.push(action.payload); // Add new candidate to state
//         toast.success(
//           action.payload?.message || "Candidate created successfully"
//         );
//       })
//       .addCase(createCandidate.rejected, (state, action) => {
//         state.status = "candidate_creation_failed";
//         if (Array.isArray(action.payload?.non_field_errors)) {
//           action.payload.non_field_errors.forEach((error) => {
//             toast.error(error); // Show each error using toast
//           });
//         } else {
//           toast.error(action.payload?.message || "Candidate creation failed");
//         }
//       })

//       // Get Candidate Details
//       .addCase(getCandidate.pending, (state) => {
//         state.loading.getCandidate = "pending";
//         state.status = "loading";
//       })
//       .addCase(getCandidate.fulfilled, (state, action) => {
//         state.loading.getCandidate = "succeeded";
//         state.candidateDetail = action.payload;
//         state.status = "candidate_loaded";
//       })
//       .addCase(getCandidate.rejected, (state, action) => {
//         state.loading.getCandidate = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to fetch candidate");
//       })

//       // Update Candidate
//       .addCase(updateCandidate.pending, (state) => {
//         state.loading.updateCandidate = "pending";
//         state.status = "loading";
//       })
//       .addCase(updateCandidate.fulfilled, (state, action) => {
//         state.loading.updateCandidate = "succeeded";
//         state.status = "candidate_updated";
//         state.candidates = state.candidates.map((candidate) =>
//           candidate.id === action.meta.arg.candidate_id
//             ? action.payload
//             : candidate
//         );
//         toast.success(
//           action.payload?.message || "Candidate updated successfully"
//         );
//       })
//       .addCase(updateCandidate.rejected, (state, action) => {
//         state.loading.updateCandidate = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to update candidate");
//       })

//       // Delete Candidate
//       .addCase(deleteCandidate.pending, (state) => {
//         state.loading.deleteCandidate = "pending";
//         state.status = "loading";
//       })
//       .addCase(deleteCandidate.fulfilled, (state, action) => {
//         state.loading.deleteCandidate = "succeeded";
//         state.status = "candidate_deleted";
//         state.candidates = state.candidates.filter(
//           (candidate) => candidate.id !== action.meta.arg
//         );
//         toast.success(
//           action.payload?.message || "Candidate deleted successfully"
//         );
//       })
//       .addCase(deleteCandidate.rejected, (state, action) => {
//         state.loading.deleteCandidate = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to delete candidate");
//       })

//       // Get Candidate List
//       .addCase(getCandidateList.pending, (state) => {
//         state.loading.getCandidateList = "pending";
//         state.status = "loading";
//       })
//       .addCase(getCandidateList.fulfilled, (state, action) => {
//         // state.loading.getCandidateList = "succeeded";
//         // state.candidates = action.payload;
//         // state.status = "candidate_list_loaded";
//         state.loading.getCandidateList = "succeeded";
//         state.candidates = action.payload.results || [];
//         state.status = "candidate_list_loaded";
//       })
//       .addCase(getCandidateList.rejected, (state, action) => {
//         state.loading.getCandidateList = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(
//           action.payload?.message || "Failed to fetch candidate list"
//         );
//       })

//       // Publish Hot List
//       .addCase(publishHotList.pending, (state) => {
//         state.loading.publishHotList = "pending";
//         state.status = "loading";
//       })
//       .addCase(publishHotList.fulfilled, (state, action) => {
//         state.loading.publishHotList = "succeeded";
//         state.status = "hotlist_published";
//         state.hotLists = state.hotLists.map((hotlist) =>
//           hotlist.id === action.payload.id ? action.payload : hotlist
//         );
//         toast.success(
//           action.payload?.message || "Hotlist published successfully"
//         );
//       })
//       .addCase(publishHotList.rejected, (state, action) => {
//         state.loading.publishHotList = "failed";
//         state.status = "failed";
//         state.error = action.payload;
//         toast.error(action.payload?.message || "Failed to publish hotlist");
//       });
//   },
// });

// export default hotListSlice.reducer;

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { authApi } from "../../config/api";
import { toast } from "react-toastify";

// Create Hot List
export const createHotList = createAsyncThunk(
  "hotlist/create",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/company/recruiter/hot-list/",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Get All Hot Lists
export const getHotLists = createAsyncThunk(
  "hotlist/fetchAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await authApi.get("/company/recruiter/hot-list/");
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Delete Hot List
export const deleteHotList = createAsyncThunk(
  "hotlist/delete",
  async (hot_list_id, { rejectWithValue }) => {
    try {
      const response = await authApi.delete(
        `/company/recruiter/hot-list/?hot_list_id=${hot_list_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Create Candidate in Hot List
export const createCandidate = createAsyncThunk(
  "hotlist/createCandidate",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/company/recruiter/hot-list/candidate/",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Get Candidate Details
export const getCandidate = createAsyncThunk(
  "hotlist/getCandidate",
  async (candidate_id, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/company/recruiter/hot-list/candidate/${candidate_id}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Update Candidate
export const updateCandidate = createAsyncThunk(
  "hotlist/updateCandidate",
  async ({ candidate_id, data }, { rejectWithValue }) => {
    try {
      const response = await authApi.put(
        `/company/recruiter/hot-list/candidate/${candidate_id}/`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Delete Candidate
export const deleteCandidate = createAsyncThunk(
  "hotlist/deleteCandidate",
  async (candidate_id, { rejectWithValue }) => {
    try {
      const response = await authApi.delete(
        `/company/recruiter/hot-list/candidate/${candidate_id}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Get Candidate List by Hot List ID
export const getCandidateList = createAsyncThunk(
  "hotlist/candidateList",
  async (hot_list_id, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/company/recruiter/hot-list/candidate-list/${hot_list_id}/`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Publish Hot List
export const publishHotList = createAsyncThunk(
  "hotlist/publish",
  async (data, { rejectWithValue }) => {
    try {
      const response = await authApi.patch(
        `/company/recruiter/hot-list/publish/`,
        data
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Get Recruiter List by Hot List ID
export const getRecruiterList = createAsyncThunk(
  "hotlist/recruiterList",
  async (hot_list_id, { rejectWithValue }) => {
    try {
      const response = await authApi.get(
        `/company/recruiter/hot-list/recruiter-list/?hot_list_id=${hot_list_id}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Share Hot List to Recruiter
export const shareHotListToRecruiter = createAsyncThunk(
  "hotlist/shareHotListToRecruiter",
  async (formData, { rejectWithValue }) => {
    try {
      const response = await authApi.post(
        "/company/recruiter/hot-list/share-hot-list-to-recruiter/",
        formData
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const hotListSlice = createSlice({
  name: "hotlist",
  initialState: {
    hotLists: [],
    candidates: [],
    recruiters: [],
    candidateDetail: null,
    status: "idle",
    error: null,
    loading: {
      createHotList: "idle",
      getHotLists: "idle",
      deleteHotList: "idle",
      createCandidate: "idle",
      getCandidate: "idle",
      updateCandidate: "idle",
      deleteCandidate: "idle",
      getCandidateList: "idle",
      publishHotList: "idle",
      getRecruiterList: "idle",
      shareHotListToRecruiter: "idle", // New loading state
    },
  },
  extraReducers: (builder) => {
    builder
      // Create Hot List
      .addCase(createHotList.pending, (state) => {
        state.loading.createHotList = "pending";
        state.status = "loading";
      })
      .addCase(createHotList.fulfilled, (state, action) => {
        state.loading.createHotList = "succeeded";
        state.status = "created";
        state.hotLists.push(action.payload);
        toast.success(
          action.payload?.message || "Hotlist created successfully"
        );
      })
      .addCase(createHotList.rejected, (state, action) => {
        state.loading.createHotList = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(
          action.payload?.name?.join(", ") ||
            action.payload?.message ||
            "Failed to create hotlist"
        );
      })

      // Get All Hot Lists
      .addCase(getHotLists.pending, (state) => {
        state.loading.getHotLists = "pending";
        state.status = "loading";
      })
      .addCase(getHotLists.fulfilled, (state, action) => {
        state.loading.getHotLists = "succeeded";
        state.hotLists = action.payload;
        state.status = "succeeded";
      })
      .addCase(getHotLists.rejected, (state, action) => {
        state.loading.getHotLists = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to fetch hotlists");
      })

      // Delete Hot List
      .addCase(deleteHotList.pending, (state) => {
        state.loading.deleteHotList = "pending";
        state.status = "loading";
      })
      .addCase(deleteHotList.fulfilled, (state, action) => {
        state.loading.deleteHotList = "succeeded";
        state.status = "deleted";
        state.hotLists = state.hotLists.filter(
          (hotlist) => hotlist.id !== action.meta.arg
        );
        toast.success(
          action.payload?.message || "Hotlist deleted successfully"
        );
      })
      .addCase(deleteHotList.rejected, (state, action) => {
        state.loading.deleteHotList = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to delete hotlist");
      })

      // Create Candidate
      .addCase(createCandidate.pending, (state) => {
        state.loading.createCandidate = "pending";
        state.status = "loading";
      })
      .addCase(createCandidate.fulfilled, (state, action) => {
        state.loading.createCandidate = "succeeded";
        state.status = "candidate_created";
        state.candidates.push(action.payload);
        toast.success(
          action.payload?.message || "Candidate created successfully"
        );
      })
      .addCase(createCandidate.rejected, (state, action) => {
        state.status = "candidate_creation_failed";
        if (Array.isArray(action.payload?.non_field_errors)) {
          action.payload.non_field_errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error(action.payload?.message || "Candidate creation failed");
        }
      })

      // Get Candidate Details
      .addCase(getCandidate.pending, (state) => {
        state.loading.getCandidate = "pending";
        state.status = "loading";
      })
      .addCase(getCandidate.fulfilled, (state, action) => {
        state.loading.getCandidate = "succeeded";
        state.candidateDetail = action.payload;
        state.status = "candidate_loaded";
      })
      .addCase(getCandidate.rejected, (state, action) => {
        state.loading.getCandidate = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to fetch candidate");
      })

      // Update Candidate
      .addCase(updateCandidate.pending, (state) => {
        state.loading.updateCandidate = "pending";
        state.status = "loading";
      })
      .addCase(updateCandidate.fulfilled, (state, action) => {
        state.loading.updateCandidate = "succeeded";
        state.status = "candidate_updated";
        state.candidates = state.candidates.map((candidate) =>
          candidate.id === action.meta.arg.candidate_id
            ? action.payload
            : candidate
        );
        toast.success(
          action.payload?.message || "Candidate updated successfully"
        );
      })
      .addCase(updateCandidate.rejected, (state, action) => {
        state.loading.updateCandidate = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to update candidate");
      })

      // Delete Candidate
      .addCase(deleteCandidate.pending, (state) => {
        state.loading.deleteCandidate = "pending";
        state.status = "loading";
      })
      .addCase(deleteCandidate.fulfilled, (state, action) => {
        state.loading.deleteCandidate = "succeeded";
        state.status = "candidate_deleted";
        state.candidates = state.candidates.filter(
          (candidate) => candidate.id !== action.meta.arg
        );
        toast.success(
          action.payload?.message || "Candidate deleted successfully"
        );
      })
      .addCase(deleteCandidate.rejected, (state, action) => {
        state.loading.deleteCandidate = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to delete candidate");
      })

      // Get Candidate List
      .addCase(getCandidateList.pending, (state) => {
        state.loading.getCandidateList = "pending";
        state.status = "loading";
      })
      .addCase(getCandidateList.fulfilled, (state, action) => {
        state.loading.getCandidateList = "succeeded";
        state.candidates = action.payload.results || [];
        state.status = "candidate_list_loaded";
      })
      .addCase(getCandidateList.rejected, (state, action) => {
        state.loading.getCandidateList = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(
          action.payload?.message || "Failed to fetch candidate list"
        );
      })

      // Publish Hot List
      .addCase(publishHotList.pending, (state) => {
        state.loading.publishHotList = "pending";
        state.status = "loading";
      })
      //   .addCase(publishHotList.fulfilled, (state, action) => {
      //     state.loading.publishHotList = "succeeded";
      //     state.status = "hotlist_published";
      //     state.hotLists = state.hotLists.map((hotlist) =>
      //       hotlist.id === action.payload.id ? action.payload : hotlist
      //     );
      //     toast.success(
      //       action.payload?.message || "Hotlist published successfully"
      //     );
      //   })
      .addCase(publishHotList.fulfilled, (state, action) => {
        state.loading.publishHotList = "succeeded";
        state.status = "hotlist_published";

        const { hot_list_ids, is_publish } = action.meta.arg;
        state.hotLists = state.hotLists.map((hotlist) =>
          hot_list_ids.includes(hotlist.id)
            ? { ...hotlist, is_publish }
            : hotlist
        );

        toast.success(
          action.payload?.message || "Hotlist published successfully"
        );
      })
      .addCase(publishHotList.rejected, (state, action) => {
        state.loading.publishHotList = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(action.payload?.message || "Failed to publish hotlist");
      })

      // Get Recruiter List
      .addCase(getRecruiterList.pending, (state) => {
        state.loading.getRecruiterList = "pending";
        state.status = "loading";
      })
      .addCase(getRecruiterList.fulfilled, (state, action) => {
        state.loading.getRecruiterList = "succeeded";
        state.recruiters = action.payload.results || action.payload;
        state.status = "recruiter_list_loaded";
      })
      .addCase(getRecruiterList.rejected, (state, action) => {
        state.loading.getRecruiterList = "failed";
        state.status = "failed";
        state.error = action.payload;
        toast.error(
          action.payload?.message || "Failed to fetch recruiter list"
        );
      })

      // Share Hot List to Recruiter
      .addCase(shareHotListToRecruiter.pending, (state) => {
        state.loading.shareHotListToRecruiter = "pending";
        state.status = "loading";
      })
      .addCase(shareHotListToRecruiter.fulfilled, (state, action) => {
        state.loading.shareHotListToRecruiter = "succeeded";
        state.status = "hotlist_shared";
        if (action.payload.hotlist) {
          state.hotLists = state.hotLists.map((hotlist) =>
            hotlist.id === action.payload.hotlist.id
              ? action.payload.hotlist
              : hotlist
          );
        }
        toast.success(action.payload?.message || "Hotlist shared successfully");
      })
      .addCase(shareHotListToRecruiter.rejected, (state, action) => {
        state.loading.shareHotListToRecruiter = "failed";
        state.status = "failed";
        state.error = action.payload;
        if (Array.isArray(action.payload?.non_field_errors)) {
          action.payload.non_field_errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error(action.payload?.message || "Failed to share hotlist");
        }
      });
  },
});

export default hotListSlice.reducer;
